/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteRemovePersonalizationMutationResponse, DeleteRemovePersonalizationPathParams, DeleteRemovePersonalization404 } from "../../models/DeleteRemovePersonalization";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteRemovePersonalizationUrl({ uuid, printOptionCode }: { uuid: DeleteRemovePersonalizationPathParams["uuid"]; printOptionCode: DeleteRemovePersonalizationPathParams["printOptionCode"] }) {
  const res = { method: 'DELETE', url: `/api/v1/configurations/${uuid}/print-options/${printOptionCode}/personalization` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid/print-options/:printOptionCode/personalization}
 */
export async function deleteRemovePersonalization({ uuid, printOptionCode }: { uuid: DeleteRemovePersonalizationPathParams["uuid"]; printOptionCode: DeleteRemovePersonalizationPathParams["printOptionCode"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteRemovePersonalizationMutationResponse, ResponseErrorConfig<DeleteRemovePersonalization404>, unknown>({ method : "DELETE", url : getDeleteRemovePersonalizationUrl({ uuid, printOptionCode }).url.toString(), ... requestConfig })  
  return res.data
}